import { RequestLog } from '@engine/models'

interface GetTrackingStatusBadgeProps {
  log: RequestLog
}

const statusBadgeClass: Record<string, string> = {
  delivered: 'badge-success',
  'in-transit': 'badge-info',
  'out-for-delivery': 'badge-info',
  'enroute-to-pickup': 'badge-warning',
  pending: 'badge-warning',
  'not-found': 'badge-neutral',
  error: 'badge-error',
}

const GetTrackingStatusBadge = ({ log }: GetTrackingStatusBadgeProps) => {
  const responseContent = log.tenantResponse?.content as any

  // Error responses from mapError have { status: 'error', errorType, errors }
  // Successful tracking responses have { currentStatus: { status }, errors? }
  const isError =
    responseContent?.status === 'error' ||
    responseContent?.currentStatus?.status === 'error'
  const trackingStatus = isError
    ? 'error'
    : (responseContent?.currentStatus?.status as string | undefined)

  if (!trackingStatus) {
    return <span className="text-xs opacity-50">N/A</span>
  }

  const badgeClass = statusBadgeClass[trackingStatus] ?? 'badge-neutral'

  if (isError) {
    const errorType =
      (responseContent?.errorType as string | undefined) ||
      (responseContent?.errors?.[0]?.type as string | undefined)
    return (
      <span className={`badge badge-sm ${badgeClass}`}>
        {errorType || 'error'}
      </span>
    )
  }

  return (
    <span className={`badge badge-sm ${badgeClass}`}>{trackingStatus}</span>
  )
}

export { GetTrackingStatusBadge }
